// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import type { Location } from 'react-router';
import { scrollToHash } from 'utils/scrollIntoView';
import type { Org } from 'api/orgs';
import type { CurrentUser } from 'api/currentUser';
import { partialUpdateOrg as apiUpdateOrg } from 'api/orgAdmin';
import SearchContextHeaderContainer from 'containers/SearchContextHeaderContainer';
import { trackPageView } from 'utils/analytics';
import { fetchOrg, partialUpdateOrg } from '../redux/main/actions/orgs';
import LoadingPage from './LoadingPage';
import OrgPage from './OrgPage';
import { updateCurrentUser } from '../redux/main/actions/currentUser';
import { setDocumentTitle } from '../utils/meta';

const trackOrg = ({ name, id, orgType }: Org) => {
  trackPageView('Org Listing Page', {
    name,
    id,
    org_type: orgType,
    page_type: 'Org Listings'
  });
};

type Props = {
  orgId: string,
  location: Location,
  currentUser: CurrentUser,
  partialUpdateOrg: typeof partialUpdateOrg,
  updateCurrentUser: typeof updateCurrentUser,
  org: ?Org,
  fetchOrg: Function
};

class ViewContainer extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.fetchOrg(this.props.orgId);
    const org = this.props.org;
    if (org) {
      trackOrg(org);
      setDocumentTitle(org.name);
    }
    scrollToHash(this.props.location.hash.replace('section-', ''));
  }

  componentDidUpdate(prevProps) {
    const lastOrg = prevProps.org;
    const org = this.props.org;
    if (org && (!lastOrg || lastOrg.id !== org.id)) {
      scrollToHash(this.props.location.hash.replace('section-', ''));
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    nextProps.fetchOrg(nextProps.orgId);
    const org = nextProps.org;
    if (org && (!this.props.org || this.props.org.id !== org.id)) {
      trackOrg(org);
      setDocumentTitle(org.name);
    }
  }

  onSubmit = ({
    values,
    handleError
  }: {
    values: Object,
    handleError: Function
  }) => {
    apiUpdateOrg(values)
      .then(() => {
        this.props.partialUpdateOrg(values);
      })
      .catch(handleError);
  };

  render() {
    const { org, currentUser } = this.props;
    if (!org) {
      return <LoadingPage />;
    }
    return (
      <SearchContextHeaderContainer
        currentObjectId={org.id}
        render={searchContext => (
          <OrgPage
            org={org}
            searchContext={searchContext}
            currentUser={currentUser}
            isPublished
            onSubmit={this.onSubmit}
          />
        )}
      />
    );
  }
}

const mapStateToProps = (
  { currentUser, orgs: { byId } },
  { orgId }: { orgId: string }
) => {
  const org = byId[orgId];
  if (!org || org.isFetching) {
    return { currentUser };
  }
  return { currentUser, org };
};

export default withRouter(
  connect(
    mapStateToProps,
    { updateCurrentUser, partialUpdateOrg, fetchOrg }
  )(ViewContainer)
);
